import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label']

  connect() {
    this.updateTitleBeforeRender = this.updateTitleBeforeRender.bind(this)
    document.addEventListener('turbo:before-frame-render', this.updateTitleBeforeRender)
  }

  disconnect() {
    document.removeEventListener('turbo:before-frame-render', this.updateTitleBeforeRender)
  }

  updateTitleBeforeRender(event) {
    const frame = event.target
    if (frame.id !== 'main') return

    const newTitle = event.detail.newFrame.dataset.title
    if (!newTitle) return

    this.labelTarget.textContent = newTitle
    document.title = `${newTitle} – LodgeLink`
  }
}
